import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faMicrochip } from "@fortawesome/free-solid-svg-icons";

export default class Projects extends Component {
  render() {
    // const { getInterface } = this.props;

    return (
      <div className="flex justify-center">
        <div className="w-full lg:w-7/12 p-4 lg:px-0 lg:py-4">
          <h3 className="text-3xl font-semibold mt-8">View My Projects</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-10">
            {/* <!-- CARD 1 --> */}
            <div className="rounded overflow-hidden shadow-lg flex flex-col">
              <div className="relative">
                <img
                  className="w-full"
                  src={`${process.env.PUBLIC_URL}/images/archive/website-geopark-pasaman.png`}
                  alt="Website Geopark Pasaman"
                ></img>
                <div className="absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25 hover:opacity-50 transition duration-300"></div>
                <p
                  href="#"
                  className="absolute top-0 right-0 bg-indigo-600 px-4 py-2 text-white mt-3 mr-3 rounded-md"
                >
                  Website
                </p>
              </div>
              <div className="px-6 py-4 mb-auto">
                <h5 className="font-medium text-lg hover:text-indigo-600 transition duration-500 ease-in-out block mb-2">
                  Geopark Pasaman
                </h5>
                <p class="text-gray-500 text-sm">
                  Mengembangkan prototipe profil website untuk rencana
                  pengembangan Geopark Ekuator Pasaman.
                </p>
              </div>
              <div
                class={`px-6 py-3 flex flex-row items-center justify-between bg-gray-300`}
              >
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faClock} />
                  <span className="ml-2 text-sm font-semibold">2024</span>
                </div>
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faMicrochip} />
                  <p className="ml-1 text-sm">Wordpress, Elementor</p>
                </div>
              </div>
            </div>

            {/* <!-- CARD 2 --> */}
            <div className="rounded overflow-hidden shadow-lg flex flex-col">
              <div className="relative">
                <img
                  className="w-full"
                  src={`${process.env.PUBLIC_URL}/images/archive/halal-partner-mho.png`}
                  alt="Halal Partner MHO"
                ></img>
                <div className="absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25 hover:opacity-50 transition duration-300"></div>
                <p
                  href="https://halalpartner.com/mho"
                  className="absolute top-0 right-0 bg-indigo-600 px-4 py-2 text-white mt-3 mr-3 rounded-md"
                >
                  Website
                </p>
              </div>
              <div className="px-6 py-4 mb-auto">
                <h5 className="font-medium text-lg hover:text-indigo-600 transition duration-500 ease-in-out block mb-2">
                  Halal Partner MHO
                </h5>
                <p class="text-gray-500 text-sm">
                  Mengembangkan Role Mitra Halal Officer (MHO) pada website
                  Halal Partner MHO dari Majelis Ulama Indonesia (MUI).
                </p>
              </div>
              <div class="px-6 py-3 flex flex-row items-center justify-between bg-gray-300">
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faClock} />
                  <span className="ml-2 text-sm font-semibold">2025</span>
                </div>
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faMicrochip} />
                  <p className="ml-1 text-sm">ReactJS, Laravel</p>
                </div>
              </div>
            </div>

            {/* <!-- CARD 3 --> */}
            <div className="rounded overflow-hidden shadow-lg flex flex-col">
              <div className="relative">
                <img
                  className="w-full"
                  src={`${process.env.PUBLIC_URL}/images/archive/image-placeholder.webp`}
                  alt="Sunset in the mountains"
                ></img>
                <div className="absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25 hover:opacity-50 transition duration-300"></div>
                <p
                  href="#"
                  className="absolute top-0 right-0 bg-indigo-600 px-4 py-2 text-white mt-3 mr-3 rounded-md"
                >
                  #
                </p>
              </div>
              <div className="px-6 py-4 mb-auto">
                <h5 className="font-medium text-lg hover:text-indigo-600 transition duration-500 ease-in-out block mb-2">
                  Lorem Ipsum
                </h5>
                <p class="text-gray-500 text-sm">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Dolorem, dolorum?
                </p>
              </div>
              <div class="px-6 py-3 flex flex-row items-center justify-between bg-gray-300">
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faClock} />
                  <span className="ml-2 text-sm font-semibold">2024</span>
                </div>
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faMicrochip} />
                  <p className="ml-1 text-sm">lorem, ipsum</p>
                </div>
              </div>
            </div>

            {/* <!-- CARD 4 --> */}
            <div className="rounded overflow-hidden shadow-lg flex flex-col">
              <div className="relative">
                <img
                  className="w-full"
                  src={`${process.env.PUBLIC_URL}/images/archive/image-placeholder.webp`}
                  alt="Sunset in the mountains"
                ></img>
                <div className="absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25 hover:opacity-50 transition duration-300"></div>
                <p
                  href="#"
                  className="absolute top-0 right-0 bg-indigo-600 px-4 py-2 text-white mt-3 mr-3 rounded-md"
                >
                  #
                </p>
              </div>
              <div className="px-6 py-4 mb-auto">
                <h5 className="font-medium text-lg hover:text-indigo-600 transition duration-500 ease-in-out block mb-2">
                  Lorem Ipsum
                </h5>
                <p class="text-gray-500 text-sm">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Dolorem, dolorum?
                </p>
              </div>
              <div class="px-6 py-3 flex flex-row items-center justify-between bg-gray-300">
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faClock} />
                  <span className="ml-2 text-sm font-semibold">2024</span>
                </div>
                <div className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                  <FontAwesomeIcon icon={faMicrochip} />
                  <p className="ml-1 text-sm">lorem, ipsum</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
